// extracted by mini-css-extract-plugin
export default {"items":"oQdRmEq__a3vi3SfmlvV"};